import { Text } from '@thanx/uikit/text'
import type { ResolvedBy } from 'api/recoveryAi.types'
import AiGeneratedBadge from 'components/AiGeneratedBadge'
import type { SurfaceVariant } from 'components/orderFeedbackSurface'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('components.recent_activities')

type Props = {
  resolvedBy: ResolvedBy
  // Which surface this cell renders on. The RAI case detail (default) renders
  // the em-dash placeholder for a null operator name (the norm everywhere); the
  // Reports order-rating redesign renders a BLANK cell (Option B) instead.
  variant?: SurfaceVariant
}

// Who resolved the prior record: the shared AiGeneratedBadge (variant="resolved")
// — the "THANX AI" pill + a decorative magic-wand — or a human operator name.
// `kind` is 'ai' | 'operator' | null; a null kind falls to the operator-name
// branch.
const ResolvedByCell = ({ resolvedBy, variant = 'case-detail' }: Props) => {
  const blankWhenNameless = variant === 'order-rating'
  switch (resolvedBy.kind) {
    case 'ai':
      return <AiGeneratedBadge variant="resolved" />
    default:
      return (
        <Text.BodyText4 color="grey90">
          {resolvedBy.name ?? (blankWhenNameless ? '' : t('empty'))}
        </Text.BodyText4>
      )
  }
}

export default ResolvedByCell
